import React from 'react';
import { Button } from 'react-bootstrap';
import useStepper from '../useStepper';

export const PreviousStepButton: React.FC = () => {
  const { hasPrevious, showPrevious } = useStepper();

  if (!hasPrevious) return null;

  return (
    <Button variant="light" onClick={showPrevious}>
      Previous
    </Button>
  );
};
